import './Tabs.scss'

import React, { useCallback } from 'react'
import { useLocation, withRouter } from 'react-router-dom'

import Icon from '../../components/Icon/Icon'
import classNames from 'classnames'

const Tab = withRouter(({ to, title, icon, history }) => {
  const { pathname } = useLocation()
  const handleClick = useCallback(() => history.push(to), [history, to])

  return (
    <div
      className={classNames('-tab', { '-active': to === pathname })}
      onClick={handleClick}
    >
      <div className='-content'>
        <Icon size={32} icon={icon} />
        <div className={classNames("-label", "label-field-sized-basic")}>{title}</div>
      </div>
      <div className='-selection-line'></div>
    </div>
  )
})

const Tabs = ({ children }) => {
  return <div className='tabs'>{children}</div>
}

export { Tabs, Tab }
